import { currencyUtils } from '~/utils/currency.utils';
import { ServiceCostType } from './model';
export function isFixedPrice(cost) {
    return cost.pricingType === ServiceCostType.Fixed;
}
export function isVariablePrice(cost) {
    return cost.pricingType === ServiceCostType.Variable;
}
export function isRangePrice(cost) {
    return cost.pricingType === ServiceCostType.Range;
}
export function price(cost) {
    if (cost.pricingType === ServiceCostType.Fixed) {
        return cost.price;
    } else if (cost.pricingType === ServiceCostType.Variable) {
        return cost.price;
    } else {
        return cost.maxPrice;
    }
}
export function applyDiscount(cost) {
    if (isFixedPrice(cost) || isVariablePrice(cost)) {
        return currencyUtils.applyDiscount(cost.price, cost.discount);
    } else {
        return currencyUtils.applyDiscount(cost.maxPrice, cost.discount);
    }
}
